<template>
  <div>
    <!-- start wrapper -->
    <div class="password-reset__wrapper">
      <!-- start container -->
      <div class="login__container">
        <div class="row">
          <!-- left side: end -->
          <!-- left side: part 1 start -->
          <div
            class="
              col-12 col-sm-12 col-xs-12 col-md-6 col-lg-6 col-xl-6
              login__loginCard--leftSide
            "
          >
            <div class="login-form">
              <h2 class="login__maintitle--text">Change Password</h2>
              <p class="login__subtitle--text">
                It's time to change your password
              </p>
              <div
                class="alert alert-success login__card--notify-bar"
                id="submit_success"
                v-if="resetSuccess"
              >
                {{ successMessage }}
              </div>
              <div
                class="alert alert-danger login__card--notify-bar"
                id="submit_error"
                v-if="resetFail"
              >
                {{ errrorMessage }}
                <ul>
                  <li v-for="(error, index) in errorLoop" :key="index">
                    * {{ error }}
                  </li>
                </ul>
              </div>

              <form class="login__form" @submit="formSubmit">
                <input type="hidden" name="userId" id="userId" value="" />
                <div class="inputBox" v-if="is_new_logn">
                  <input
                    :type="currentPasswordFieldType"
                   v-model="currentPassword"
                   name="currentPassword"
                    id="cur"
                    autocomplete="off"
                    required
                  />
                  <span
                    class="login__password--show--hide"
                    @click="switchCurrentPassowrdVisibility"
                  >
                    <span v-if="displayCurrentPasswordText" class="">
                      <img src="https://img.icons8.com/ios/22/000000/visible--v1.png" style="opacity: 0.6;"/>                                          
                    </span>
                    <span v-else>
                      <img src="https://img.icons8.com/ios/22/000000/hide.png" style="opacity: 0.6;"/>                      
                    </span>
                  </span>
                  <label>CURRENT PASSWORD</label>
                </div>

                <div class="inputBox">
                  <input
                    :type="newPasswordFieldType"
                    v-model="password"
                    name="newPassword"
                    id="new"
                    required
                    data-trigger="focus"
                    autocomplete="off"
                    data-skin="dark"
                    data-toggle="m-tooltip"
                    data-placement="bottom"
                    title="Password must contain minimum of 8 characters with the combination of (A-Z, a-z, 0-9, and at least one special character..&,$,@,#,!,%)"
                  />
                  <span
                    class="login__password--show--hide"
                    @click="switchNewPassowrdVisibility"
                  >
                    <span v-if="displayNewPasswordText" class="">
                      <img
                        src="https://img.icons8.com/ios/22/000000/visible--v1.png"
                        style="opacity: 0.6"
                      />
                    </span>
                    <span v-else>
                      <img
                        src="https://img.icons8.com/ios/22/000000/hide.png"
                        style="opacity: 0.6"
                      />
                    </span>
                  </span>

                  <label>NEW PASSWORD</label>
                </div>

                <div class="inputBox">
                  <input
                    :type="confirmPasswordFieldType"
                    v-model="confirmPassword"
                    name="confirmPassword"
                    id="new1"
                    required
                    data-trigger="focus"
                    autocomplete="off"
                    data-skin="dark"
                    data-toggle="m-tooltip"
                    data-placement="bottom"
                    title="Password must contain minimum of 8 characters with the combination of (A-Z, a-z, 0-9, and at least one special character..&,$,@,#,!,%)"
                  />
                  <span
                    class="login__password--show--hide"
                    @click="switchConfirmPassowrdVisibility"
                  >
                    <span v-if="displayConfirmPasswordText" class="">
                      <img
                        src="https://img.icons8.com/ios/22/000000/visible--v1.png"
                        style="opacity: 0.6"
                      />
                    </span>
                    <span v-else>
                      <img
                        src="https://img.icons8.com/ios/22/000000/hide.png"
                        style="opacity: 0.6"
                      />
                    </span>
                  </span>

                  <label>CONFIRM PASSWORD</label>
                </div>

                <div>
                  <button
                    v-if="is_new_logn"
                    class="btn btn__login mt-3 mb-3"
                    @click.prevent="formNewPasswordSubmit"
                    href="javascript:;"
                    id="m_login_password_reset_submit"
                  >
                    Change Password
                  </button>
                  <button
                    v-else
                    class="btn btn__login mt-3 mb-3"
                    @click.prevent="formSubmit"
                    href="javascript:;"
                    id="m_login_password_reset_submit"
                  >
                    Change Password
                  </button>
                </div>

                <div>
                  <button
                    class="btn btn__login--login--back"
                    @click.prevent="goBack"
                    href="javascript:;"
                    id="m_login_password_reset_submit"
                  >
                    Go Back
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- left side: part 1 start -->

          <!-- Right side: start -->
          <div
            class="p-0 col-12 col-sm-12 col-xs-12 col-md-6 col-lg-6 col-xl-6"
          >
            <img
              :src="login_side_background_img"
              class="col-right__oraganization--image"
              alt=""
            />
          </div>
          <!-- Right side: end -->
        </div>
      </div>
      <!-- end container -->

      <!-- slogan text -->
      <div class="credit" v-if="organization_slogan">
        {{ organization_slogan }}
      </div>
      <!-- Visit WEb button: visible in mobile view -->
      <div class="login__btn-site--mobile">
        <a
          class="login__desktop--visit--mobile--btn"
          :href="web_site_url"
          target="_blank"
          type="button"
        >
          Visit Website
        </a>
      </div>
    </div>
    <!-- end wrapper -->

    <!-- <div class="loader_wrapper" v-if="isLoading">
      <div class="loader_block">
        <loading
          :active.sync="isLoading"
          :color="'#f7941d'"
          :loader="'spinner'"
          :can-cancel="false"
          :is-full-page="false"
        ></loading>
      </div>
    </div> -->
  </div>
</template>

<script>
// import Loading from "vue-loading-overlay";
var Config = require("../router/Config");
// var $ = require('jquery')
var Cookies = require("vue-cookies");

module.exports = {
  name: "force_reset",
  props: ["authenticated"],
  data() {
    return {
      currentPasswordFieldType: "password",
      newPasswordFieldType: "password",
      confirmPasswordFieldType: "password",
      displayCurrentPasswordText: true,
      displayConfirmPasswordText: true,
      displayNewPasswordText: true,
      currentPassword: "",
      password: "",
      confirmPassword: "",
      resetSuccess: false,
      resetFail: false,
      successMessage: "",
      errrorMessage: "",
      errorLoop: [],
      logo_url: Config.LOGO_URL(),
      loging_background: Config.LOGIN_BACKGROUND(),
      isLoading: false,
      organization_slogan: "",
      login_side_background_img: "",
      web_site_url: "",
      token: "",
      is_new_logn: true,
    };
  },
  mounted() {
    this.getLogo();
    this.token = this.$route.query.token;
    if (typeof this.token !== "undefined") {
      //if token set
      this.is_new_logn = false;
    }
  },
  methods: {
    //password reset when forgot password
    formSubmit: function () {
      this.axios
        .post(Config.API_URL + "/api/auth/forceReset", {
          type: "student",
          token: this.token,
          new: this.password,
          new1: this.confirmPassword,
          userId: Cookies.get("userId"),
        })
        .then((response) => {
          var result = response.data;
          var self = this;
          if (result.res === "1") {
            this.resetSuccess = true;
            this.successMessage = "Password Reset Success.!";
            setTimeout(function () {
              self.resetSuccess = false;
              self.$router.replace({ name: "login" });
            }, 1000);
          } else if (result.res === "0") {
            this.resetSuccess = false;
            this.resetFail = true;
            this.errrorMessage = result.data;
            if (result.errorArray) {
              this.errorLoop = result.errorArray;
            }
          } else if (result.res === "2") {
            this.resetSuccess = false;
            this.resetFail = true;
            this.errrorMessage =
              "Your account seem to be blocked. Please contact the administrator.";
          } else {
            this.resetSuccess = false;
            this.resetFail = true;
            this.errrorMessage = "Please try Again!!";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    goBack: function () {
      var appos = Cookies.get("appos");
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/auth/removeSession?token=" +
            Cookies.get("accessToken"),
          {
            deviceSessionId: Cookies.get("deviceSessionId"),
          }
        )
        .then((response) => {
          var allCookies = Cookies.keys();
          allCookies.forEach((items) => {
            Cookies.remove(items);
          });
          clearInterval(this.sessionInterval);
          this.$emit("authenticated", false);
          if (this.isMobile) {
            this.logoutFromMobileApp(appos, "");
          }
          location.reload();
        })
        .catch(function (error) {
          console.log(error);
        });
      this.$router.replace({ name: "login" });
    },
    logoutFromMobileApp: function (appos, message) {
      try {
        if (appos === "ios") {
          if (window.webkit) {
            window.webkit.messageHandlers.logout.postMessage(message);
          }
        } else if (appos === "android") {
          Android.logout(message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLogo: function () {
      this.axios
        .post(Config.API_URL + "/api/company-logo", {
          url: document.location.origin,
          type: "front",
        })
        .then((response) => {
          var result = response.data.data;
          this.organization_slogan = result.org_slogan;
          this.login_side_background_img = result.background_image;
          this.web_site_url = result.website;
          // Cookies.set("company_logo", result.logo_image);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    switchCurrentPassowrdVisibility() {
      this.displayCurrentPasswordText = !this.displayCurrentPasswordText;
      this.currentPasswordFieldType =
        this.currentPasswordFieldType === "password" ? "text" : "password";
    },
    switchNewPassowrdVisibility() {
      this.displayNewPasswordText = !this.displayNewPasswordText;
      this.newPasswordFieldType =
        this.newPasswordFieldType === "password" ? "text" : "password";
    },
    switchConfirmPassowrdVisibility() {
      this.displayConfirmPasswordText = !this.displayConfirmPasswordText;
      this.confirmPasswordFieldType =
        this.confirmPasswordFieldType === "password" ? "text" : "password";
    },
    //reset password new user first time login
    formNewPasswordSubmit: function () {
      this.axios.post(Config.API_URL + '/api/fe/auth/forceReset' + '?token=' + Cookies.get('accessToken'), {
        cur: this.currentPassword,
        new: this.password,
        new1: this.confirmPassword,
        userId: Cookies.get('userId')
      }).then(response => {
        // console.log('forceReset')
        console.log(response.data)
        var result = response.data
        var self = this
        if (result.res === '1') {
          console.log(result.data)
          this.resetSuccess = true
          this.successMessage = 'Password Reset Success.!'
          setTimeout(function () {
            self.resetSuccess = false
            self.$router.replace({ name: 'login' })
          }, 1000)
        } else if (result.res === '0') {
          this.resetSuccess = false
          this.resetFail = true
          this.errrorMessage = result.data
          if (result.errorArray) {
            this.errorLoop = result.errorArray
          }
        } else if (result.res === '2') {
          this.resetSuccess = false
          this.resetFail = true
          this.errrorMessage = 'Your account seem to be blocked. Please contact the administrator.'
        } else {
          this.resetSuccess = false
          this.resetFail = true
          this.errrorMessage = 'Please try Again!!'
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
  },
};
</script>

<style scoped lang="scss">
// @import "../assets/scss/component/login/login";
// @import "../assets/css/login/login-extra.css";
@import "../assets/scss/component/login/login_new.scss";

#submit_success {
  color: #155724 !important;
}

.alert {
  position: relative !important;
  padding: 0.75rem 1.25rem !important;
  margin-bottom: 1rem !important;
  border: 1px solid transparent !important;
  border-radius: 0.25rem !important;
  box-shadow: none !important;
}

.alert-success {
  color: #155724 !important;
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
}

.alert-danger {
  color: #943213 !important;
  background-color: #fdddd2 !important;
  border-color: #fdcbbc !important;
}
</style>
